import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserStateService } from '../services/user-state/user-state';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userStateService = inject(UserStateService);
  const router = inject(Router);

  const requiredPermission = route.data['requiredPermission'] as string | undefined;
  const requiredPermissions = route.data['requiredPermissions'] as string[] | undefined;
  const requireAll = route.data['requireAllPermissions'] as boolean | undefined;
  const fallbackRoute = route.data['fallbackRoute'] as string | undefined;

  if (!requiredPermission && !requiredPermissions) {
    return true;
  }

  if (!userStateService.isUserLoaded()) {
    router.navigate(['/login']);
    return false;
  }

  let hasAccess = false;

  if (requiredPermission) {//Single permission
    hasAccess = userStateService.hasPermission(requiredPermission);
  } else if (requiredPermissions) {//Multiple permissions
    hasAccess = requireAll
      ? userStateService.hasAllPermissions(requiredPermissions)
      : userStateService.hasAnyPermission(requiredPermissions);
  }

  //Redirect to fallback route if user doesn't have access
  if (!hasAccess) {
    const redirectTo = fallbackRoute || '/chat';
    router.navigate([redirectTo]);
    return false;
  }

  return true;
};

